import {
  convertToBlockquoteCommand,
  convertToCardCommand,
  insertCardCommand,
  singleCardKeymap,
} from './singleCardCommands';
import { singleCardNode } from './singleCardNode';
import { singleCardRemark } from './singleCardRemark';
import { singleCardView } from './singleCardView';

/**
 * Single Card Plugin for Milkdown.
 *
 * Provides first-class support for emoji-prefixed cards in the editor.
 * Works in tandem with the grouped-cards plugin to provide a complete
 * card authoring experience.
 *
 * Usage:
 * ```typescript
 * import { singleCardPlugin } from './plugins/singleCard';
 *
 * const crepe = new Crepe({ ... });
 * crepe.editor.use(singleCardPlugin);
 * ```
 *
 * Features:
 * - ✅ Card node schema with cardType attribute (win, warning, quote, note)
 * - ✅ DOM-based view with type-specific styling
 * - ✅ Shared remark plugin for perfect view/edit parity
 * - ✅ Insert, convert, and keyboard commands
 * - ✅ Keyboard shortcuts (Mod-Alt-w, Mod-Alt-a, Mod-Alt-q, Mod-Alt-n)
 *
 * Card Types:
 * - win (✅): Success/achievement cards - green styling
 * - warning (⚠️): Alert/caution cards - amber styling
 * - quote (💬): Quotes/highlights - blue styling
 * - note (🗒️): General notes - neutral gray styling
 */
export const singleCardPlugin = [
  singleCardRemark,
  singleCardNode,
  singleCardView,
  insertCardCommand,
  convertToCardCommand,
  convertToBlockquoteCommand,
  singleCardKeymap,
].flat();

// Export individual pieces for testing
export {
  convertToBlockquoteCommand,
  convertToCardCommand,
  insertCardCommand,
  singleCardKeymap,
  singleCardNode,
  singleCardRemark,
  singleCardView,
};
